import "./App.css";
import axios from "axios";
import React from "react";
import SelectionScreen from "./components/SelectionScreen";
import { name } from "./config";

function App() {
  const [password, setPassword] = React.useState("");
  const [authenticated, setAuthenticated] = React.useState(false);
  React.useEffect(() => {
    if (localStorage.getItem("SLMPassword")) {
      axios
        .post(process.env.REACT_APP_BACKEND_URL + "/auth", {
          password: localStorage.getItem("SLMPassword"),
        })
        .then((res) => {
          if (res.data === "success") {
            setAuthenticated(true);
            setPassword(localStorage.getItem("SLMPassword"));
          }
        })
        .catch((reason) => {
          console.log("/auth failed", reason);
          alert("Kirjautuminen epäonnistui \nVirheviesti:" + reason.message);
        });
    }
  }, [setPassword]);

  function submit(event) {
    event.preventDefault();
    axios
      .post(process.env.REACT_APP_BACKEND_URL + "/auth", { password })
      .then((res) => {
        if (res.data === "success") {
          setAuthenticated(true);
          localStorage.setItem("SLMPassword", password);
        }
      })
      .catch((reason) => {
        console.log("/auth failed", reason);
        alert("Kirjautuminen epäonnistui \nVirheviesti:" + reason.message);
      });
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1 className="app-title">SLM bussityökalu {name}</h1>
        {authenticated ? (
          <SelectionScreen />
        ) : (
          <form className="login-form" onSubmit={submit}>
            <label>Salasana: </label>
            <input
              className="password-input"
              type="password"
              name="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
            ></input>
            {/* <br /> */}
            <input className="send-button" type="submit" value="Lähetä"></input>
          </form>
        )}
      </header>
    </div>
  );
}

export default App;
